import charts from '../charts.js';

export default function({ id, data, config, dates, settings = {} }) {
	settings = {
		data,
		legend: false,
		skipChartReady: true,

		scrollbar: {
			series: {
				valueYField: 'chart_close',
			},
		},

		... settings,
	};

	const chart = charts.draw(id, settings, dates);

	chart.historicalSeries = chart.addSeries(
		chart.lineSeries({
			name: 'historical',
			valueYField: 'close',
			layer: 5,
			tooltip: {
				labelFunction({ date_formatted, weeksAgo, symbol, close }) {
					if (+weeksAgo === 0) {
						return `${symbol} closed at [bold]$${close}[/] at the end of the last trading day (${date_formatted}).`;
					}

					return `Week ending ${date_formatted} (${weeksAgo} weeks ago)\n${symbol} closed at [bold]$${close}.[/]`;
				},
			},
		})
	);

	chart.percentAxis = chart.addYAxis(chart.panel, {
		renderer: {
			opposite: true,
			minGridDistance: 20,
		},
		numberFormat: "#'%'",
		strictMinMax: true,
		strictMinMaxSelection: true,
		visible: false,
		grid: {
			opacity: 0,
		},
	});

	chart.seasonalitySeries = chart.addSeries(
		chart.lineSeries(
			{
				name: 'future',
				valueYField: 'projected_close',
				layer: 5,
				strokeDasharray: charts.values.strokeDash,
				tooltip: {
					labelFunction({ date, symbol, gain_loss, projected_close, probability, week, base_close, best_period, weeksAgo }) {
						if (!projected_close || isNaN(gain_loss) || weeksAgo === 0) {
							return null;
						}

						const text = [];

						text.push(`${symbol} projected to [bold]${gain_loss > 0 ? 'rise' : 'fall'} by ${Math.abs(gain_loss).toFixed(2)}%[/] and close at \n[bold]\$${projected_close} [/]over the next ${week} weeks based on the most recent trading day's closing price of \$${base_close}.  The historical accuracy of this stock rising is [bold]${probability}%.[/]`);

						if (best_period) {
							text.push(`[${charts.colours.green.toCSSHex()}; bold]Best Period: [${charts.colours.green.toCSSHex()}]${symbol} has risen [${charts.colours.green.toCSSHex()}]by an [${charts.colours.green.toCSSHex()}]average of \n[${charts.colours.green.toCSSHex()}; bold]${best_period.average}% [${charts.colours.green.toCSSHex()}]during [${charts.colours.green.toCSSHex()}]this [${charts.colours.green.toCSSHex()}]${best_period.weeks}-week period [${charts.colours.green.toCSSHex()}]with a [${charts.colours.green.toCSSHex()}]track \n[${charts.colours.green.toCSSHex()}]record of [${charts.colours.green.toCSSHex()}; bold]${best_period.track_record}%.[/]`);
						}

						return text.join("\n\n");
					}
				},
			},
		)
	);

	chart.addGuide(config.lastData.timestamp, chart.xAxis);

	chart.addEarnings();

	return chart;
};
